module.exports = __webpack_public_path__ + "img/icon-certificate.8ba20179.svg";